import {Widget} from "base/assets/js/widget/Widget.js";
import {Editor} from "base/assets/js/widget/Editor.js";

export class EditorImg extends Widget {

	run() {
		this._on( '', 'load', () => {
			const oEditor = this._rel().parent().typeOf( Editor ).canEmpty().find();
			if( oEditor ) {
				oEditor.showAndUpdateToolbar();
			}
		} );
	}
}